// ESM-friendly wrapper around the local vfs_fonts.js
// Ensure the script executes and attaches fonts to a global pdfMake
import "./vfs_fonts.js";

const g =
  typeof globalThis !== "undefined"
    ? globalThis
    : typeof window !== "undefined"
    ? window
    : typeof self !== "undefined"
    ? self
    : {};

// Export the pdfMake object that vfs_fonts.js populated
export default g.pdfMake;

// The only fonts in vfs_fonts.js. pdfmake falls back to Roboto when a document names no font,
// and Roboto is not in this vfs, so createPdf rejects silently and "Print to PDF" does nothing.
// Inconsolata has no Greek glyphs; the printable pages are English.
export const PDF_FONT = "Inconsolata";
export const PDF_FONTS = {
  Inconsolata: {
    normal: "Inconsolata-Regular.ttf",
    bold: "Inconsolata-Bold.ttf",
    italics: "Inconsolata-Light.ttf",
    bolditalics: "Inconsolata-SemiBold.ttf",
  },
};
